(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('souneri-diaries-carousel')) {
    customElements.define(
      'souneri-diaries-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;

          this.track = this.querySelector('.sd-track');
          this.cards = Array.from(this.querySelectorAll('.sd-card'));
          this.controls = this.querySelector('.sd-controls');
          this.previous = this.querySelector('[data-prev]');
          this.next = this.querySelector('[data-next]');
          this.count = this.querySelector('[data-count]');

          if (!this.track || !this.cards.length) return;

          this.previous.addEventListener(
            'click',
            () => this.move(-1),
            { signal }
          );

          this.next.addEventListener(
            'click',
            () => this.move(1),
            { signal }
          );

          this.track.addEventListener(
            'scroll',
            () => this.update(),
            { passive: true, signal }
          );

          this.track.addEventListener(
            'keydown',
            (event) => {
              if (event.target !== this.track) return;

              if (event.key === 'ArrowRight') {
                event.preventDefault();
                this.move(1);
              }

              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                this.move(-1);
              }
            },
            { signal }
          );

          if ('ResizeObserver' in window) {
            this.observer = new ResizeObserver(() => this.update());
            this.observer.observe(this.track);
          } else {
            window.addEventListener(
              'resize',
              () => this.update(),
              { signal }
            );
          }

          this.update();
        }

        getStep() {
          if (this.cards.length > 1) {
            return (
              this.cards[1].getBoundingClientRect().left -
              this.cards[0].getBoundingClientRect().left
            );
          }

          return this.cards[0].getBoundingClientRect().width;
        }

        move(direction) {
          const reducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          this.track.scrollBy({
            left: direction * this.getStep(),
            behavior: reducedMotion ? 'auto' : 'smooth'
          });
        }

        update() {
          const maxScroll =
            this.track.scrollWidth - this.track.clientWidth;
          const position = Math.max(0, this.track.scrollLeft);
          const step = this.getStep();

          this.controls.hidden = maxScroll <= 2;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= maxScroll - 2;

          const visibleCount = this.cards.filter((card) => {
            const bounds = card.getBoundingClientRect();
            const trackBounds = this.track.getBoundingClientRect();

            return (
              bounds.left >= trackBounds.left - 2 &&
              bounds.right <= trackBounds.right + 2
            );
          }).length;

          const first = Math.min(
            this.cards.length,
            Math.round(position / step) + 1
          );

          const last = Math.min(
            this.cards.length,
            first + Math.max(visibleCount, 1) - 1
          );

          this.count.textContent =
            (last > first ? first + '–' + last : first) +
            ' / ' +
            this.cards.length;
        }

        disconnectedCallback() {
          if (this.controller) this.controller.abort();
          if (this.observer) this.observer.disconnect();
          this.controller = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
